import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

import './index.css';

const StepCabequip = (props) => {
  return (
    <Step
      id="cabequip"
      nonext
      title={props.getPersonalDetailsTitle('Cabcharge Equipment')}
      skip={(formdata) => !props.getApplicant().spotto || formdata.onboardingFor === 'vehicle'}>
      <Typography variant="body1" class="formQuestion">
        Do you have a Cabcharge electronic payments terminal?
      </Typography>
      <ButtonField
        id="cabequip"
        value={true}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="cabequip"
        value={false}
        label="No"
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepCabequip;
